import { Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import choiceBanner from '../../assets/images/banner.jpg';

import './Footer.css';

export function Footer(props) {

    return (
        <Container className="footer" fluid>
            <Row>
                <Col xs={12} md="6">
                    <Link to="/"><img src={choiceBanner} alt="Choice Social Club Banner Logo" /></Link>
                </Col>
                <Col xs="6" md="3">
                    <div><b>Choice Social Club</b></div>
                    <div>Providence RI</div>
                    <div><a href="tel:4012743700">(401) 274-3700</a></div>
                </Col>
                <Col xs="6" md="3">
                    <div><b>Site Map</b></div>
                    <div><Link to="/join">Join Now!</Link></div>
                    <div><Link to="/memberships">Memberships</Link></div>
                    <div><Link to="/event-calendar">Calendar</Link></div>
                    <div><Link to="/policy">Policies</Link></div>
                </Col>
            </Row>
            <Row>
                <Col xs="12" className="text-center">
                    Copyright &copy; 2008 - {new Date().getUTCFullYear()} Choice Social Club All Rights Reserved. 
                </Col>
            </Row>
        </Container>
    );
}

